import React from 'react';
import { Animated, TouchableOpacity, View, Text, Platform, ScrollView, NativeScrollEvent, NativeSyntheticEvent} from 'react-native';
import {Connection, ConnectionOrd, ISettings, ConnectionHis, IChartSettings, IIndicator, } from '../~Utilities/Connection';
import {Data, } from '../~Utilities/Data';
import Modal from "react-native-modal";
import Utilities from '../~Utilities/Utilities';
import ModalEx from './ModalEx';
import { AppMain, FontInfo, IndicatorInfo, IPeriodInfo } from '../~Utilities/Constants';
import SwitchNE from '../C_Text/SwitchNoError';
import { AntDesign, Entypo, FontAwesome, Ionicons, MaterialCommunityIcons, MaterialIcons, SimpleLineIcons } from '@expo/vector-icons';
import Svg, { G, Path } from 'react-native-svg';
import { Lato_400Regular } from '@expo-google-fonts/lato';

/*   ------------------------------------------------------------------------   */

const DEFAULT_OPACITY   = 0.4;
const SCROLL_DELTA      = 70;
const PRESS_DELTA       = 40;

const PERIOD1           = 0;
const PERIOD2           = 1;
const PERIOD3           = 2;

/*   ------------------------------------------------------------------------   */

export interface IChartConfigStateToChart
  {
  chart_type?           : number;

  index_sel?            : number;
  index_prev?           : number;

  col_index?            : number;
  line_width?           : number;

  overlay?              : boolean;

  period1?              : number;
  period2?              : number;
  period3?              : number;
  }

/*   ------------------------------------------------------------------------   */

interface IChartConfigState
  {
  visible               : boolean;
  AnimOp                : Animated.Value;    

  chart_type?           : number;
  indicators            : boolean[];

  //indicator?            : number;
  ind_index?            : number;
  period_index          : number;

  col_index             : number;
  line_width            : number;

  period1               : number;
  period2               : number;
  period3               : number;
  }

/*   ------------------------------------------------------------------------   */

const B_SETT_BIG    = 35;
const B_SETT_SMALL  = 30;

/*   ------------------------------------------------------------------------   */

export interface IChartConfig
{
  oData           : Data;
  iSettIndex      : number;
  oSettings?      : IChartSettings;
}

/*   ====================================================================   */

export default class ChartConfig extends React.Component<IChartConfig>
 {
  public static readonly MSG_CHANGE_TYPE        = 3;
  public static readonly MSG_CHANGE_INDICATOR   = 4;
  public static readonly MSG_CHANGE_PERIOD      = 5;
  public static readonly MSG_CHANGE_COL         = 6;
  public static readonly MSG_CHANGE_WIDTH       = 7;

  /*   -------------------------------------------------------------------   */

  public static readonly TYPE_LINE   = 0;
  public static readonly TYPE_CANDLE = 1;
  public static readonly TYPE_NONE   = 2;

  /*   -------------------------------------------------------------------   */

  state      : IChartConfigState;

    /*   -------------------------------------------------------------------   */

  private onConfirmApply : Array<(  (iMsg:number, oData:any) => void  )> = [  ];

  /*   -------------------------------------------------------------------   */

  private oScrollRefOvr : ScrollView | null   = null;
  private iScrollIndOvr : number              = 0;
  private oScrollRefUdr : ScrollView | null   = null;
  private iScrollIndUdr : number              = 0;  
  private oTimer        : NodeJS.Timer | null = null;

  private oLbls  : number[] = new Array(ConnectionHis.oIndicators.length);
  private bOnce  : boolean  = false;
  private iTotal : number   = 0;

  /*   -------------------------------------------------------------------   */

  Refresh()
  {
  this.forceUpdate();
  }

  /*   -------------------------------------------------------------------   */

  ApplySettings(onApply : (iMsg: number, oData: any)=>void, 
                           bSubscribe: boolean)
  {
  if (bSubscribe)
    this.onConfirmApply.push(onApply);
  else
    {
    var iZ = this.FindValueEvent(onApply);

    if (iZ != -1)
      this.onConfirmApply.splice(iZ, 1);
    }
  }

  /*   -------------------------------------------------------------------   */

  FindValueEvent(oEvent)
  {
  for (let i = 0; i < this.onConfirmApply.length; i++)
    if (this.onConfirmApply[i] == oEvent)
      return(i);

  return(AppMain.IMAGINARY);
  }

  /*   -------------------------------------------------------------------   */

  
  HideModal()
  {
  ModalEx.oModalEx?.Hide();

  /*   -------------------------------------------------------------------   */

  this.setState({
     visible       : false,
     });

  ConnectionOrd.SaveSettingsSymbol({token: this.props.oData.token, 
                                    oChartSettings:{iChartType: this.state.chart_type,
                                                    iColIndex : this.state.col_index,
                                                    iLineWidth: this.state.line_width,
                                                    oIndicators2:ConnectionOrd.
                                                    GetIndicatorList(this.state.ind_index != undefined? 
                                                                     ConnectionHis.oIndicators[this.state.ind_index].iId : undefined,
                                                                     this.state.period1,
                                                                     this.state.period2,
                                                                     this.state.period3)}});
                                                                      // this.state.period_index)}});
  }

  /*   -------------------------------------------------------------------   */

  Increment(delta : number = 1)
  {
    switch(this.state.period_index)
      {
      case PERIOD1:
        this.setState({period1: this.state.period1 + delta});
        this.informAll(ChartConfig.MSG_CHANGE_PERIOD, 
                       {
                        index_sel: this.state.ind_index,

                        period1: this.state.period1 + delta,
                        period2: this.state.period2,
                        period3: this.state.period3,
                       });
        break;
      case PERIOD2:
        this.setState({period2: this.state.period2 + delta});
        this.informAll(ChartConfig.MSG_CHANGE_PERIOD, 
                       {
                        index_sel: this.state.ind_index,
                        
                        period1: this.state.period1,
                        period2: this.state.period2 + delta,
                        period3: this.state.period3,
                       });
        break;
      case PERIOD3:
        this.setState({period3: this.state.period3 + delta});
        this.informAll(ChartConfig.MSG_CHANGE_PERIOD, 
                       {
                        index_sel: this.state.ind_index,
                        
                        period1: this.state.period1,
                        period2: this.state.period2,
                        period3: this.state.period3 + delta,
                      });
        break;        
      }

    // if (this.state.period_index == 0)
    //   {
    //   let iPeriod1 = this.state.period1 + delta;
    //   let iPeriod2 = this.state.period2; //Math.round(iPeriod1/2);
    
    //   this.setState({period1: iPeriod1, period2: iPeriod2});
    //   this.informAll(ChartConfig.MSG_CHANGE_PERIOD, 
    //                  {index_sel:this.state.ind_index, period1: iPeriod1, period2: iPeriod2});
    //   }
    // else
    //   {
    //   this.setState({period2: this.state.period2 + delta});
    //   this.informAll(ChartConfig.MSG_CHANGE_PERIOD, 
    //                  {index_sel:this.state.ind_index, period1: this.state.period1, period2:this.state.period2 + delta});
    //   }
  }

  /*   -------------------------------------------------------------------   */

  Decrement(delta : number = 1)
  {
    switch(this.state.period_index)
      {
      case PERIOD1:
        let iNew = this.state.period1 - delta;

        if (iNew < 1)
          iNew = 1;

        if (this.state.period1 == iNew)
          return;  

        this.setState({period1: iNew});
        this.informAll(ChartConfig.MSG_CHANGE_PERIOD, 
                       {
                        index_sel: this.state.ind_index,

                        period1: iNew,
                        period2: this.state.period2,
                        period3: this.state.period3,
                        });
        break;
      case PERIOD2:
        iNew = this.state.period2 - delta;

        if (iNew < 1)
          iNew = 1;

        if (this.state.period2 == iNew)
          return;  

        this.setState({period2: iNew});
        this.informAll(ChartConfig.MSG_CHANGE_PERIOD, 
                       {
                        index_sel: this.state.ind_index,

                        period1: this.state.period1,
                        period2: iNew,
                        period3: this.state.period3,
                        });
        break;
      case PERIOD3:
        iNew = this.state.period3 - delta;

        if (iNew < 1)
          iNew = 1;

        if (this.state.period3 == iNew)
          return;  

        this.setState({period3: iNew});
        this.informAll(ChartConfig.MSG_CHANGE_PERIOD, 
                       {
                        index_sel: this.state.ind_index,

                        period1: this.state.period1,
                        period2: this.state.period2,
                        period3: iNew,
                       });
        break;        
      }

  // if (this.state.period_index == 0)
  //   {
  //   let iPeriod1 = this.state.period1 - delta;

  //   if (iPeriod1 <= 0) 
  //       iPeriod1 = 1;

  //   let iPeriod2 = this.state.period2; //Math.round(iPeriod1/2);

  //   this.setState({period1: iPeriod1, period2: iPeriod2});
  //   this.informAll(ChartConfig.MSG_CHANGE_PERIOD, 
  //                  {index_sel:this.state.ind_index, period1: iPeriod1, period2: iPeriod2});
  //   }
  // else
  //   {
  //   let iPeriod = this.state.period2 - delta;

  //   if (iPeriod <= 0) 
  //       iPeriod = 1;
  
  //   this.setState({period2: iPeriod});
  //   this.informAll(ChartConfig.MSG_CHANGE_PERIOD, 
  //                  {index_sel:this.state.ind_index, period1: this.state.period1, period2: iPeriod});
  //   }

  }

  /*   -------------------------------------------------------------------   */

  componentDidMount()
  {
  }

  /*   -------------------------------------------------------------------   */

  componentWillUnmount()
  {
  this.onConfirmApply.splice(0, this.onConfirmApply.length);

  this.stopTimer();
  }

  /*   ------------------------------------------------------------------   */

  readonly getPeriodString = (oPd : IPeriodInfo) =>
  {
  if (oPd == undefined)
    return("");

  if (!oPd.iPeriod2)
    return oPd.iPeriod1.toFixed();
  else
    return oPd.iPeriod2 + "/" + oPd.iPeriod1;
  }

  /*   -------------------------------------------------------------------   */

  async informAll(iMsg : number, oData: IChartConfigStateToChart)
  {
  for (let i = 0; i < this.onConfirmApply.length; i++)
    {
    this.onConfirmApply[i](iMsg, oData);
    }
  }

  /*   -------------------------------------------------------------------   */

  SvgComponent = (props) =>
  {
  return (
    <Svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="_x32_"
    width={props.size}
    height={props.size}
    fill={props.color}
    viewBox="0 0 512 512"
    {...props}
  >
    <G id="SVGRepo_iconCarrier">
      <Path
        d="M195.047 75.844h-16.25v33.203h-40.641v211.297h40.641v39.953h16.25v-39.953h40.641V109.047h-40.641zM512 49.438h-40.625V16.25h-16.266v33.188h-40.64V293.25h40.64v39.953h16.266V293.25H512zM56.875 203.172h-16.25v36.578H0v219.422h40.625v36.578h16.25v-36.578h40.656V239.75H56.875v-36.578zM81.281 256v186.922H16.25V256h65.031zM333.203 151.703h-16.25v33.188h-40.641v227.563h40.641v39.953h16.25v-39.953h40.641V184.891h-40.641v-33.188zm24.391 49.453v195.047h-65.031V201.156h65.031z"
        />
    </G>
  </Svg>
  );
  }

  /*   -------------------------------------------------------------------   */
  
  stopTimer()
  {
  if (this.oTimer)
    {
    clearInterval(this.oTimer);
    this.oTimer = null;
    }
  }

  /*   -------------------------------------------------------------------   */

  scrollTo(iDelta : number) 
  {
  if (iDelta < 0)
    {
    if (this.iScrollIndOvr <= 0)
      return;
    }

  this.oScrollRefOvr?.scrollTo({x: this.iScrollIndOvr + iDelta, animated:true})

  if (this.oTimer)
    return;
    //clearTimeout(this.oTimer);

  this.oTimer = setInterval(this.scrollTo, 100, iDelta);
  }

  /*   -------------------------------------------------------------------   */

  // scrollTo(iDelta : number) 
  // {
  // if (iDelta < 0)
  //   {
  //   if (this.iScrollIndOvr <= 0)
  //     return;

  //   this.iScrollIndOvr--;
  //   }
  // else
  //   {
  //   if (this.iScrollIndOvr >= this.oLbls.length)
  //     return;

  //   this.iScrollIndOvr++;
  //   }



  // this.oScrollRefOvr?.scrollTo({x: this.oLbls[this.iScrollIndOvr], animated:true})

  // if (this.oTimer)
  //   return;
  //   //clearTimeout(this.oTimer);

  // this.oTimer = setInterval(this.scrollTo, 100, iDelta);
  // }

  /*   -------------------------------------------------------------------   */

  componentDidUpdate()
  {
    //this.scrollSelected();

    // if (this.state.ind_index != undefined && this.bOnce == false)
    //   {
    //   this.oScrollRefOvr?.scrollTo({x: this.oLbls[this.state.ind_index], animated:false})
    //   }

    // this.bOnce = true;    
  }

  /*   -------------------------------------------------------------------   */

  scrollSelected()
  {
    if (this.state.ind_index != undefined && this.bOnce == false)
      {
      let iWidth = this.state.ind_index < this.oLbls.length - 1? this.oLbls[this.state.ind_index + 1] - this.oLbls[this.state.ind_index] : 20;
      let iLeft  = 80 - iWidth/2;
      //this.oScrollRefOvr?.scrollTo({x: this.oLbls[this.state.ind_index], animated:false})
      this.oScrollRefOvr?.scrollTo({x: this.oLbls[this.state.ind_index] - iLeft, animated:false})
      }

    this.bOnce = true;    
  }

  /*   -------------------------------------------------------------------   */

  renderType()
  {
    return(
    <View style={{flexDirection:'row', marginTop:5}}>
    {/* Line */}
    <TouchableOpacity 
    style={{backgroundColor:'transparent', margin:5, alignItems:'center', borderBottomWidth:3,
            borderBottomColor:this.state.chart_type==ChartConfig.TYPE_LINE? FontInfo.sLightGreen:'transparent'}}
        onPress={()=>
          {
            this.setState(  {chart_type: ChartConfig.TYPE_LINE}  );
            this.informAll(ChartConfig.MSG_CHANGE_TYPE, {chart_type: ChartConfig.TYPE_LINE});
          }}> 
         {/* <SimpleLineIcons name="graph" size={20} color={FontInfo.sForeground } />  */}
         {/* <MaterialIcons name="show-chart" size={24} color={FontInfo.sForeground } /> */}
         <MaterialCommunityIcons name="chart-timeline-variant" size={24} color={FontInfo.sForeground } />
        <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', padding:0, minWidth:40, color:FontInfo.sForeground}]} //'rgba(255,255,255,.8)'}]} //color:'rgba(255,255,255,.8)'}]}
        >Line</Text>
    </TouchableOpacity>

    {/* Candle */}
    <TouchableOpacity 
    style={{backgroundColor:'transparent', margin:5, alignItems:'center', borderBottomWidth:3,
            borderBottomColor:this.state.chart_type==ChartConfig.TYPE_CANDLE? FontInfo.sLightGreen:'transparent'}}
        onPress={()=>
          {
            this.setState(  {chart_type: ChartConfig.TYPE_CANDLE}  );
            this.informAll(ChartConfig.MSG_CHANGE_TYPE, {chart_type: ChartConfig.TYPE_CANDLE});
          }}> 
         {/* <Entypo name="bar-graph" size={24} color={this.state.chart_type==ChartConfig.TYPE_CANDLE? FontInfo.sLightGreen:FontInfo.sForeground } />  */}
         {/* <Ionicons name="bar-chart-outline" size={24} color={this.state.chart_type==ChartConfig.TYPE_CANDLE? FontInfo.sLightGreen:FontInfo.sForeground } /> */}
         {/* <MaterialCommunityIcons name="chart-waterfall" size={24} color={this.state.chart_type==ChartConfig.TYPE_CANDLE? FontInfo.sLightGreen:FontInfo.sForeground } /> */}
         {/* <SimpleLineIcons name="chart" size={20} color={this.state.chart_type==ChartConfig.TYPE_CANDLE? FontInfo.sGreen:FontInfo.sForegroundTp } /> */}
         <this.SvgComponent color={FontInfo.sForeground} size={24}/>
        <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', padding:0, minWidth:40, color:FontInfo.sForeground}]} //'rgba(255,255,255,.8)'}]}
        >Candle</Text>
    </TouchableOpacity>

    {/* NONE */}
    <TouchableOpacity 
          style={{backgroundColor:'transparent', margin:5, alignItems:'center', borderBottomWidth:3,
          borderBottomColor:this.state.chart_type==ChartConfig.TYPE_NONE? FontInfo.sLightGreen:'transparent'}}
        onPress={()=>
          {
            this.setState(  {chart_type: ChartConfig.TYPE_NONE}  );
            this.informAll(ChartConfig.MSG_CHANGE_TYPE, {chart_type: ChartConfig.TYPE_NONE});
          }}> 
        <MaterialCommunityIcons name="circle-off-outline" size={24} color={FontInfo.sForeground } />            
        <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', padding:0, minWidth:40, color:FontInfo.sForeground}]} //'rgba(255,255,255,.8)'}]}
        >None</Text>
    </TouchableOpacity>
    </View>
    );
  }

  /*   -------------------------------------------------------------------   */

  renderIndicatorsOvr()
  {
  return(
    <View style={{marginVertical:5, alignItems:'center'}}>
    <View style={{flexDirection:'row', alignItems:'center', }}>
    <TouchableOpacity style={{marginHorizontal:5, marginTop:-6, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                  padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:'transparent',//'rgba(118,118,118,.5)', 
                                  borderWidth:1}} 
                                  // onPressIn={()=>{this.oScrollRefOvr?.scrollTo({x: this.iScrollIndOvr - 10})}}
                                  onPressIn={ ()=>{this.scrollTo(-SCROLL_DELTA)} }
                                  onPressOut= { ()=>{this.stopTimer()} }
                                  >

    <AntDesign style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -1 }} name="left" size={18} color= {FontInfo.sLightGreen} />
    </TouchableOpacity>


    <ScrollView horizontal style={{minHeight:40, maxHeight:40, minWidth:160, maxWidth:160,}} 
                showsHorizontalScrollIndicator={false}
                scrollEventThrottle={0}
                
                ref={(node)=> this.oScrollRefOvr = node}
                onScroll={(event)=> this.iScrollIndOvr = event.nativeEvent.contentOffset.x}
                >
    <View style={{backgroundColor:'transparent', flexDirection:'row', alignItems:'center'}}>
        {
        ConnectionHis.oIndicators.map((oInd: IndicatorInfo, iIndex: number)=> 
        {
          return(
            <TouchableOpacity 
            key={iIndex}

            onLayout={(event) => {
                      this.oLbls[iIndex] = event.nativeEvent.layout.x;
                      this.iTotal++;

                      if (this.iTotal >= this.oLbls.length - 1)
                        {
                          this.scrollSelected();

                          // if (this.state.ind_index != undefined && this.bOnce == false)
                          //   {
                          //   this.oScrollRefOvr?.scrollTo({x: this.oLbls[this.state.ind_index], animated:false})
                          //   this.bOnce = true;
                          //   }
                        }
                      }}

            style={{backgroundColor:'transparent', margin:4, alignItems:'center', borderBottomWidth:3,
                    borderBottomColor:this.state.indicators[iIndex]? '#0096FF' : 'transparent'}}
                onPress={()=>
                  {
                    let oInds : boolean[] = new Array(this.state.indicators.length);

                    oInds[iIndex] = !this.state.indicators[iIndex];

                    this.setState(  {indicators: oInds, 
                                     ind_index: oInds[iIndex]? iIndex : undefined,
                                     period_index: !oInds[iIndex] || !ConnectionHis.oIndicators[iIndex].iPeriod2? 0 : this.state.period_index
                                     });

                    this.informAll(ChartConfig.MSG_CHANGE_INDICATOR, {index_sel: oInds[iIndex]? iIndex : undefined, //ConnectionHis.oIndicators[iIndex].iId : undefined, 
                                                                      index_prev: this.state.ind_index,
                                                                      period1:this.state.period1, 
                                                                      period2:this.state.period2,
                                                                      period3:this.state.period3,
                                                                    
                                                                      overlay: ConnectionHis.oIndicators[iIndex].bOverlay
                                                                      });

                    }}> 

            <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', paddingHorizontal:1, paddingBottom:2, minWidth:0, color:FontInfo.sForeground}]}>{ConnectionHis.oIndicators[iIndex].sId}</Text>
            </TouchableOpacity>
      
          //   <TouchableOpacity key={iIndex} style={{borderRadius:5, 
          //     backgroundColor:this.state.indicators[iIndex]? FontInfo.sLightGreen : 'rgba(105,105,105,.6)', margin:3,}}
          //     onPress={()=>
          //       {
          //         let oInds : boolean[] = new Array(this.state.indicators.length);

          //         oInds[iIndex] = !this.state.indicators[iIndex];

          //         this.setState(  {indicators: oInds, 
          //                          indicator: oInds[iIndex]? iIndex : undefined,
          //                          period_index: !oInds[iIndex] || !ConnectionHis.oIndicators[iIndex].iPeriod2? 0 : this.state.period_index
          //                          });

          //         this.informAll(ChartConfig.MSG_CHANGE_INDICATOR, {indicator: oInds[iIndex]? iIndex : undefined, period1:this.state.period1, period2:this.state.period2});

          //       }}> 
          //     <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', padding:5, minWidth:30, color:'rgba(255,255,255,.8)'}]}>{ConnectionHis.oIndicators[iIndex].sId}</Text>

          //  </TouchableOpacity>
        )})
        }


      </View>
      </ScrollView>

      <TouchableOpacity style={{marginHorizontal:5, marginTop:-6, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                  padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:'transparent',//'rgba(118,118,118,.5)', 
                                  borderWidth:1}} 
                                  // onPressIn={()=>{this.oScrollRefOvr?.scrollTo({x: this.iScrollIndOvr + 10}); Utilities.Sendlog("pressed: " + Date.now());  }}>
                                  onPressIn={ ()=>{this.scrollTo(SCROLL_DELTA)} }
                                  onPressOut= { ()=>{this.stopTimer()} }
                                  >

      <AntDesign style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -1 }} name="right" size={18} color= {FontInfo.sLightGreen} />
      {/* <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen} /> */}
    </TouchableOpacity>


    </View>

    <Text style={[FontInfo.appStyles.txt_bold, {marginTop:0, paddingVertical:0, fontSize: FontInfo.iFontSize-1  , color:FontInfo.sForegroundTp}]}>{this.state.ind_index != undefined? ConnectionHis.oIndicators[this.state.ind_index].sDesc : "No Indicator"}</Text>
    </View>
  ); 
  }

  /*   -------------------------------------------------------------------   */

  // renderIndicatorsUdr()
  // {
  // return(
  //   <View style={{marginVertical:5, alignItems:'center'}}>
  //   <View style={{flexDirection:'row', alignItems:'center', }}>
  //   <TouchableOpacity style={{marginHorizontal:10, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
  //                                 padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
  //                                 borderWidth:1}} 
  //                                 // onPressIn={()=>{this.oScrollRefOvr?.scrollTo({x: this.iScrollIndOvr - 10})}}
  //                                 onPressIn={ ()=>{this.scrollTo(this.oScrollRefUdr, this.iScrollIndUdr, -SCROLL_DELTA)} }
  //                                 onPressOut= { ()=>{this.stopTimer()} }
  //                                 >

  //   <AntDesign style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -1 }} name="left" size={18} color= {FontInfo.sLightGreen} />
  //   </TouchableOpacity>


  //   <ScrollView horizontal style={{minHeight:40, maxHeight:40, minWidth:160, maxWidth:160,}} 
  //               showsHorizontalScrollIndicator={false}
  //               scrollEventThrottle={30}
                
  //               ref={(node)=> this.oScrollRefUdr = node}
  //               onScroll={(event)=> this.iScrollIndUdr = event.nativeEvent.contentOffset.x}
  //               >
  //   <View style={{backgroundColor:'transparent', flexDirection:'row', alignItems:'center'}}>
  //       {
  //       ConnectionHis.oIndicators.map((oInd: IndicatorInfo, iIndex: number)=> 
  //       {
  //         return(
  //           <TouchableOpacity key={iIndex}
  //           style={{backgroundColor:'transparent', margin:4, alignItems:'center', borderBottomWidth:3,
  //                   borderBottomColor:this.state.indicators[iIndex]? '#0096FF' : 'rgba(105,105,105,.6)'}}
  //               onPress={()=>
  //                 {
  //                   let oInds : boolean[] = new Array(this.state.indicators.length);

  //                   oInds[iIndex] = !this.state.indicators[iIndex];

  //                   this.setState(  {indicators: oInds, 
  //                                    indicator: oInds[iIndex]? iIndex : undefined,
  //                                    period_index: !oInds[iIndex] || !ConnectionHis.oIndicators[iIndex].iPeriod2? 0 : this.state.period_index
  //                                    });

  //                   this.informAll(ChartConfig.MSG_CHANGE_INDICATOR, {indicator: oInds[iIndex]? iIndex : undefined, period1:this.state.period1, period2:this.state.period2});

  //                   }}> 

  //           <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', paddingHorizontal:2, paddingBottom:2, minWidth:30, color:FontInfo.sForeground}]}>{ConnectionHis.oIndicators[iIndex].sId}</Text>
  //           </TouchableOpacity>
      
  //         //   <TouchableOpacity key={iIndex} style={{borderRadius:5, 
  //         //     backgroundColor:this.state.indicators[iIndex]? FontInfo.sLightGreen : 'rgba(105,105,105,.6)', margin:3,}}
  //         //     onPress={()=>
  //         //       {
  //         //         let oInds : boolean[] = new Array(this.state.indicators.length);

  //         //         oInds[iIndex] = !this.state.indicators[iIndex];

  //         //         this.setState(  {indicators: oInds, 
  //         //                          indicator: oInds[iIndex]? iIndex : undefined,
  //         //                          period_index: !oInds[iIndex] || !ConnectionHis.oIndicators[iIndex].iPeriod2? 0 : this.state.period_index
  //         //                          });

  //         //         this.informAll(ChartConfig.MSG_CHANGE_INDICATOR, {indicator: oInds[iIndex]? iIndex : undefined, period1:this.state.period1, period2:this.state.period2});

  //         //       }}> 
  //         //     <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', padding:5, minWidth:30, color:'rgba(255,255,255,.8)'}]}>{ConnectionHis.oIndicators[iIndex].sId}</Text>

  //         //  </TouchableOpacity>
  //       )})
  //       }


  //     </View>
  //     </ScrollView>

  //     <TouchableOpacity style={{marginHorizontal:10, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
  //                                 padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
  //                                 borderWidth:1}} 
  //                                 // onPressIn={()=>{this.oScrollRefOvr?.scrollTo({x: this.iScrollIndOvr + 10}); Utilities.Sendlog("pressed: " + Date.now());  }}>
  //                                 onPressIn={ ()=>{this.scrollTo(this.oScrollRefUdr, this.iScrollIndUdr, SCROLL_DELTA)} }
  //                                 onPressOut= { ()=>{this.stopTimer()} }
  //                                 >

  //     <AntDesign style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -1 }} name="right" size={18} color= {FontInfo.sLightGreen} />
  //     {/* <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen} /> */}
  //   </TouchableOpacity>


  //   </View>

  //   <Text style={[FontInfo.appStyles.txt_normal, {marginTop:0, paddingVertical:0, fontSize: FontInfo.iFontSize , color:FontInfo.sForegroundTp}]}>{this.state.indicator != undefined? ConnectionHis.oIndicators[this.state.indicator].sDesc : ""}</Text>
  //   </View>
  // ); 
  // }

  /*   -------------------------------------------------------------------   */

  renderCol()
  {
    return(
    <>  
    <View style={{backgroundColor:'transparent', flexDirection:'row', marginTop:6 }}>



    {
    ConnectionHis.oColors.map((oColData : string[], iIndex: number)=>{
      return(
        <TouchableOpacity key={iIndex}
                          style={{flexDirection:'row', borderWidth:iIndex==this.state.col_index?2:2, 
                                  borderColor: iIndex==this.state.col_index? FontInfo.sLightGreen : 'transparent',
                                  width:20,
                                  height:20,
                                  marginHorizontal:4, borderRadius:10, }}
          onPress={()=>
            {
              this.setState({col_index: iIndex});
              this.informAll(ChartConfig.MSG_CHANGE_COL,
                             {
                              col_index: iIndex
                             });
      
            }}
          >

        <View style={{//position:'absolute', left:0, top:0, minWidth:19, minHeight:38, overflow:'hidden',
                      flex:1, overflow:'hidden',
                      backgroundColor:iIndex==2? '#A0A0A0' : oColData[0], 
                      borderTopLeftRadius:10, borderBottomLeftRadius:10}}></View>
        <View style={{//position:'absolute', right:0, top:0, minWidth:19, minHeight:35, 
                      flex:1, overflow:'hidden',
                      backgroundColor:iIndex==2? '#A0A0A0' : oColData[1], 
                      borderTopRightRadius:10, borderBottomRightRadius:10}}></View>
        </TouchableOpacity>
      )})
    }
    </View>



    <View style={{backgroundColor:'transparent', flexDirection:'row', marginTop:6 }}>
    <TouchableOpacity style={{flexDirection:'row', borderWidth:0, backgroundColor: this.state.line_width==1? FontInfo.sLightGreen:FontInfo.sDimGrayTp,
                          alignItems:'center', justifyContent:'center', alignContent:'center',
                          width:18, height:18, marginHorizontal:8, borderRadius:10, overflow:'hidden' }}
      onPress={()=>
        {
          this.setState({line_width: 1});
          this.informAll(ChartConfig.MSG_CHANGE_WIDTH,
                          {
                          line_width: 1
                          });
 
        }}
      >
        <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', 
                          fontSize: FontInfo.iFontSize-4, 
                          color:FontInfo.sForeground}]}>A</Text>
    </TouchableOpacity>

    <TouchableOpacity style={{flexDirection:'row', borderWidth:0, backgroundColor: this.state.line_width==2? FontInfo.sLightGreen:FontInfo.sDimGrayTp,
                              alignItems:'center', justifyContent:'center', alignContent:'center',
                              width:18, height:18, marginHorizontal:4, borderRadius:10, overflow: 'hidden'}}
      onPress={()=>
        {
          this.setState({line_width: 2});
          this.informAll(ChartConfig.MSG_CHANGE_WIDTH,
                          {
                          line_width: 2
                          });
        }}
      >
        <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', 
                          fontSize: FontInfo.iFontSize,
                          color:FontInfo.sForeground}]}>A</Text>
    </TouchableOpacity>

    </View>

    </>
    // ConnectionHis.oColors[this.state.col_index][ConnectionHis.oIndicators[this.state.ind_index].iCol1]  
    );
  }

  /*   -------------------------------------------------------------------   */

  renderPeriods()
  {
  return(
    <View style={{backgroundColor:'transparent', flexDirection:'row', marginTop:0, minHeight:this.state.ind_index==undefined || !ConnectionHis.oIndicators[this.state.ind_index].iPeriod1? 35 : 0 }}>
    {
    this.state.ind_index==undefined || !ConnectionHis.oIndicators[this.state.ind_index].iPeriod1? null : 
    <View style={{flexDirection: 'row', justifyContent:'center', alignContent:'center', alignItems:'center'}}>

      {/* Buttons */}
      <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder, //'rgba(118,118,118,.5)', 
                                borderWidth:1}} onPress={()=>{this.Decrement(10)}}>

      <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
      </TouchableOpacity>

      <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                borderWidth:1}} onPress={()=>{this.Decrement()}}>
                                  
      <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
      </TouchableOpacity>


      {/* Period1 */}
      <View style={{flexDirection:'row', minWidth:78, justifyContent:'center', backgroundColor:'transparent'}}>

      <TouchableOpacity //style={{backgroundColor:'transparent', marginHorizontal:0}}
                        style={{backgroundColor:'transparent', marginHorizontal:0, paddingHorizontal:2, paddingTop:0,
                                borderBottomColor:this.state.period_index==PERIOD1? 
                                this.state.ind_index!=undefined && ConnectionHis.oIndicators[this.state.ind_index].iPeriod1? 
                                ConnectionHis.oColors[this.state.col_index][ConnectionHis.oIndicators[this.state.ind_index].iCol1] : 'transparent' : 'transparent',
                                borderBottomWidth: 3 }}
                        onPress={()=>
                          {
                            this.setState(  {period_index: PERIOD1}  );
                            // this.informAll(ChartSettings.MSG_CHANGE_PERIOD, iIndex);
                          }}
                      >

        {/* <View style={{backgroundColor:'transparent', marginHorizontal:5, paddingHorizontal:2, paddingTop:0,
                      borderBottomColor:this.state.period_index==0? this.state.ind_index!=undefined && ConnectionHis.oIndicators[this.state.ind_index].sCol1? ConnectionHis.oIndicators[this.state.ind_index].sCol1 : 'transparent' : 'transparent',
                      borderBottomWidth: 3 }}> */}
            <Text 
                  style={[FontInfo.appStyles.txt_bold, {textAlign:'center', 
                          padding:2, minWidth:25,
                          color:FontInfo.sForeground}]}
            >{this.state.ind_index==undefined || !this.state.period1? "" : this.state.period1}
            </Text>
        {/* </View> */}
      </TouchableOpacity>

      {/* Period2 */}
      <TouchableOpacity style={{display:this.state.ind_index==undefined||!ConnectionHis.oIndicators[this.state.ind_index].iPeriod2? 'none':'flex',
                                backgroundColor:'transparent', marginHorizontal:0,
                                paddingHorizontal:2, paddingTop:0,
                                borderBottomColor:this.state.period_index==PERIOD2? 
                                this.state.ind_index!=undefined && ConnectionHis.oIndicators[this.state.ind_index].iPeriod2? 
                                ConnectionHis.oColors[this.state.col_index][ConnectionHis.oIndicators[this.state.ind_index].iCol2] : 'transparent' : 'transparent',
                                borderBottomWidth: 3}}
                        onPress={()=>
                          {
                            this.setState(  {period_index: PERIOD2}  );
                            // this.informAll(ChartSettings.MSG_CHANGE_PERIOD, iIndex);
                          }}
                      >

        {/* <View style={{backgroundColor:'transparent', marginHorizontal:5, paddingHorizontal:2, paddingTop:0,
                      borderBottomColor:this.state.period_index==1? this.state.ind_index!=undefined && ConnectionHis.oIndicators[this.state.ind_index].sCol2? ConnectionHis.oIndicators[this.state.ind_index].sCol2 : 'transparent' : 'transparent',
                      borderBottomWidth: 3,  }}> */}
            <Text 
                  style={[FontInfo.appStyles.txt_bold, {textAlign:'center', 
                          padding:2, minWidth:25,
                          color:FontInfo.sForeground}]}
            >{this.state.ind_index==undefined || !this.state.period2? "" : this.state.period2}
            </Text>
        {/* </View> */}
      </TouchableOpacity>

      {/* Period3 */}
      <TouchableOpacity style={{display:this.state.ind_index==undefined||!ConnectionHis.oIndicators[this.state.ind_index].iPeriod3? 'none':'flex',
                                backgroundColor:'transparent', marginHorizontal:0,
                                paddingHorizontal:2, paddingTop:0,
                                borderBottomColor:this.state.period_index==PERIOD3? 
                                this.state.ind_index!=undefined && ConnectionHis.oIndicators[this.state.ind_index].iPeriod3? 
                                ConnectionHis.oColors[this.state.col_index][ConnectionHis.oIndicators[this.state.ind_index].iCol3] : 'transparent' : 'transparent',
                                borderBottomWidth: 3,}}
                        onPress={()=>
                          {
                            this.setState(  {period_index: PERIOD3}  );
                            // this.informAll(ChartSettings.MSG_CHANGE_PERIOD, iIndex);
                          }}
                      >

        {/* <View style={{backgroundColor:'transparent', marginHorizontal:5, paddingHorizontal:2, paddingTop:0,
                      borderBottomColor:this.state.period_index==2? this.state.ind_index!=undefined && ConnectionHis.oIndicators[this.state.ind_index].sCol3? ConnectionHis.oIndicators[this.state.ind_index].sCol3 : 'transparent' : 'transparent',
                      borderBottomWidth: 3,  }}> */}
            <Text 
                  style={[FontInfo.appStyles.txt_bold, {textAlign:'center', 
                          padding:2, minWidth:25,
                          color:FontInfo.sForeground}]}
            >{this.state.ind_index==undefined || !this.state.period3? "" : this.state.period3}
            </Text>
        {/* </View> */}
      </TouchableOpacity>

      </View>

      {/* Buttons */}
      <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                borderWidth:1}} onPress={()=>{this.Increment()}}>

      <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen} />
      </TouchableOpacity>

      <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                borderWidth:1}} onPress={()=>{this.Increment(10)}}>

      <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen}/>
      </TouchableOpacity>


    </View>

    // ConnectionHis.oIndicators[this.state.indicator].oPeriods.map((oPdInfo : IPeriodInfo, iIndex: number)=>{
    //   return(

    //     <TouchableOpacity key={iIndex} style={{backgroundColor:'transparent', marginHorizontal:0}}
    //       onPress={()=>
    //         {
    //           this.setState(  {period_index: iIndex}  );
    //           this.informAll(ChartSettings.MSG_CHANGE_PERIOD, iIndex);
    //         }}
    //      >

    //     <View style={{backgroundColor:'transparent', marginHorizontal:10, paddingHorizontal:2, paddingTop:0,
    //                   borderBottomColor:FontInfo.sLightGreen,
    //                   borderBottomWidth: this.state.period_index==iIndex? 2:0,  }}>
    //       <Text key={iIndex}
    //             style={[FontInfo.appStyles.txt_bold, {textAlign:'center', 
    //                     padding:5, 
    //                     color:FontInfo.sForeground}]}
    //       >
    //       {this.state.indicator==undefined? "" : this.getPeriodString(ConnectionHis.oIndicators[this.state.indicator].oPeriods[iIndex])}
    //       </Text>

    //     </View>
    //     </TouchableOpacity>

    //   )})

    }
  </View>
  );
  }

  /*   -------------------------------------------------------------------   */

  renderChartInfo()
  {
    return (
      <Modal style={{}}
        useNativeDriver={true}
        useNativeDriverForBackdrop={true}
        backdropOpacity={0.0}
        animationInTiming={400}
        animationOutTiming={300}
        animationIn={"bounceInLeft"}
        animationOut={"slideOutLeft"}
        backdropTransitionOutTiming={0}
        hideModalContentWhileAnimating={true}
        isVisible={this.state.visible}
        onBackdropPress={()=>this.HideModal()}
        >

      <View style={{alignSelf:'center', minWidth:250, minHeight:100, paddingTop:15, paddingBottom:10, paddingHorizontal:0,  
                    justifyContent:'center', alignItems:'center', 
                    borderRadius:20, backgroundColor:FontInfo.sBackgroundTp}}>

      <View style={{flexDirection:'row'}}>
      <Text style={[FontInfo.appStyles.txt_bold, {fontSize:FontInfo.iFontSize, color:FontInfo.sGreen, opacity:.9, }]}>1Min</Text>
      <Text style={[FontInfo.appStyles.txt_normal, {fontSize:FontInfo.iFontSize, marginLeft:2, color:FontInfo.sForeground, opacity:.9, fontWeight:'normal'}]}>updates every second</Text>
      </View>

      <View style={{flexDirection:'row'}}>
      <Text style={[FontInfo.appStyles.txt_bold, {fontSize:FontInfo.iFontSize, color:FontInfo.sGreen, opacity:.9, }]}>5Min</Text>
      <Text style={[FontInfo.appStyles.txt_normal, {fontSize:FontInfo.iFontSize, marginLeft:2, color:FontInfo.sForeground, opacity:.9, fontWeight:'normal'}]}>updates every 3 seconds</Text>
      </View>

      <View style={{flexDirection:'row'}}>
      <Text style={[FontInfo.appStyles.txt_bold, {fontSize:FontInfo.iFontSize, color:FontInfo.sGreen, opacity:.9, }]}>1Hr</Text>
      <Text style={[FontInfo.appStyles.txt_normal, {fontSize:FontInfo.iFontSize, marginLeft:2, color:FontInfo.sForeground, opacity:.9, }]}>updates every minute</Text>
      </View>

      <View style={{flexDirection:'row'}}>
      <Text style={[FontInfo.appStyles.txt_bold, {fontSize:FontInfo.iFontSize, color:FontInfo.sGreen, opacity:.9, }]}>1D</Text>
      <Text style={[FontInfo.appStyles.txt_normal, {fontSize:FontInfo.iFontSize, marginLeft:2, color:FontInfo.sForeground, opacity:.9, }]}>updates every 30 minutes</Text>
      </View>

      <View style={{flexDirection:'row'}}>
      <Text style={[FontInfo.appStyles.txt_bold, {fontSize:FontInfo.iFontSize, color:FontInfo.sGreen, opacity:.9, }]}>2W, 1M, 3M, 1Y</Text>
      <Text style={[FontInfo.appStyles.txt_normal, {fontSize:FontInfo.iFontSize, marginLeft:2, color:FontInfo.sForeground, opacity:.9, }]}>updates daily</Text>
      </View>

      <this.renderType/>
      <this.renderIndicatorsOvr/>
      {/* <this.renderIndicatorsUdr/> */}
      <this.renderPeriods/>
      <this.renderCol/>


      </View>

      {/* </View> */}
      </Modal>

    );
  }

  /*   -------------------------------------------------------------------   */

    constructor(props)
    {
    super(props);

    this.FindValueEvent      = this.FindValueEvent.bind(this);
    this.Refresh             = this.Refresh.bind(this);
    this.ApplySettings       = this.ApplySettings.bind(this);

    this.renderChartInfo     = this.renderChartInfo.bind(this);
    this.HideModal           = this.HideModal.bind(this);
  
    this.Increment           = this.Increment.bind(this);
    this.Decrement           = this.Decrement.bind(this);
    this.informAll           = this.informAll.bind(this);

    this.renderType          = this.renderType.bind(this);
    this.renderIndicatorsOvr = this.renderIndicatorsOvr.bind(this);
    // this.renderIndicatorsUdr = this.renderIndicatorsUdr.bind(this);
    this.renderPeriods       = this.renderPeriods.bind(this);
    this.renderCol           = this.renderCol.bind(this);
    
    this.scrollTo            = this.scrollTo.bind(this);
    this.stopTimer           = this.stopTimer.bind(this);

    this.scrollSelected      = this.scrollSelected.bind(this);

    /*   -----------------------------------------------------------------   */    

    let oCSett : IChartSettings | undefined;

    if (this.props.iSettIndex < ConnectionOrd.oSettings.length &&
        ConnectionOrd.oSettings[this.props.iSettIndex].token == this.props.oData.token)
        oCSett = ConnectionOrd.oSettings[this.props.iSettIndex]?.oChartSettings;
    else
      {
      let z = Utilities.FindItem(ConnectionOrd.oSettings, this.props.oData.token);
      
      /*   -----------------------------------------------------------------   */

      if (z != AppMain.IMAGINARY)
        {
        oCSett = ConnectionOrd.oSettings[z]?.oChartSettings;
        }
      }

    /*   -----------------------------------------------------------------   */

    let oInd       : boolean[] = new Array(ConnectionHis.oIndicators.length);
    let oIndInfo   : IIndicator | undefined;
    let iChartType : number = ChartConfig.TYPE_LINE;
    let iColIndex  : number = 0;
    let iLineWidth : number = 2;
    let iSel       : number | undefined;

    /*   -----------------------------------------------------------------   */

    if (oCSett)
      {
      if (oCSett.bCandles == true)
        iChartType = ChartConfig.TYPE_CANDLE; //   = oCSett?.bCandles? true : false;
      else if (oCSett.iChartType)
        iChartType = oCSett.iChartType;

      if (oCSett.iColIndex != undefined)
        iColIndex = oCSett.iColIndex;

      if (oCSett.iLineWidth != undefined)
        iLineWidth = oCSett.iLineWidth;        

      if (oCSett.oIndicators2?.length)
        {
        for (let i = 0; i < oCSett.oIndicators2.length; i++)
          {
          let iIndex = ConnectionHis.FindIndicatorIndex(oCSett.oIndicators2[i].iId);

          if (iIndex != undefined)
            {
            oInd[iIndex] = true;

            if (oIndInfo == undefined)
              {
              oIndInfo = oCSett.oIndicators2[i];
              iSel     = iIndex;
              }
            }
          }
        }
      else if (oCSett.oIndicators?.length)
        {
        let iIndex = ConnectionHis.FindIndicatorIndex(oCSett.oIndicators[0].iId);

        if (iIndex != undefined)
          {
          oInd[iIndex] = true;
          oIndInfo     = oCSett.oIndicators[0];
          iSel         = iIndex;
          }
        }
      }

    /*   -----------------------------------------------------------------   */      

    this.state   = 
                   {
                    visible: false,
                    AnimOp: new Animated.Value(0),

                    chart_type: iChartType,
                    //candles: oSett?.oChartSettings?.bCandles,

                    indicators: oInd,

                    //indicator: oIndInfo? oIndInfo.iId : undefined,
                    ind_index: iSel,

                    col_index : iColIndex,
                    line_width: iLineWidth,

                    period1: oIndInfo?.iPeriod1? oIndInfo.iPeriod1 : 14,
                    period2: oIndInfo?.iPeriod2? oIndInfo.iPeriod2 : 7,
                    period3: oIndInfo?.iPeriod3? oIndInfo.iPeriod3 : 3,

                    period_index: 0,
                    // indicator: oSett?.oChartSettings?.oIndicators?.length? oSett.oChartSettings.oIndicators[0].iId : undefined,
                    // period_index: oSett?.oChartSettings?.oIndicators?.length? oSett.oChartSettings.oIndicators[0].iPeriodIndex : 0,
                    };
    }

  /*   -------------------------------------------------------------------   */

  SlideIn = () => {

    Animated.timing(this.state.AnimOp, {
      toValue: DEFAULT_OPACITY,
      duration: 200,
      //easing: Easing.elastic(1), // Springy
      useNativeDriver:true
    }).start();
  };

  /*   -------------------------------------------------------------------   */

  SlideOut = () => {
    Animated.timing(this.state.AnimOp, {
      toValue: 0,
      duration: 100,
      useNativeDriver:true
    }).start(()=>{});
  };

  /*   -------------------------------------------------------------------   */

  public ShowChartInfo()
  {
  ModalEx.oModalEx?.Show();
  this.setState({visible:true})
  this.bOnce = false;
  }

  /*   -------------------------------------------------------------------   */

  render()
   {
    this.iTotal = 0;

    return(
      <View style={Connection.IsLoggedIn() == false? {display: "none"} : {alignSelf:'center', flexDirection:'row', backgroundColor:'transparent', marginTop:0, marginBottom:0, }}>

        <this.renderChartInfo/>
        </View>

      );

   }
}

/*   =====================================================================   */

